import React from 'react';
import ArticlePage from '../components/ArticlePage';
import {RawPageProps} from '../interfaces';

export default (props: RawPageProps) => {
  return (
    <ArticlePage {...props.pageContext} parentPath="news" endSocialIndex={1} />
  );
};
